import React from 'react';
import { View } from 'react-native';
import { Text } from '../Text';
import { useStyleSheet } from '../../hooks';
import { createStyleSheet } from '../../utils';
export const VolunteerBadge = ({ minimized, style }) => {
    const styles = useStyleSheet(getStyles);
    return (React.createElement(View, { style: [styles.container, style] },
        React.createElement(Text, { type: 'body', size: 'sm', weight: 'semibold', style: styles.text }, minimized ? 'V' : 'Volunteer')));
};
const getStyles = createStyleSheet(({ color, size }) => ({
    container: {
        backgroundColor: color.pending.ghost,
        borderRadius: 40,
        justifyContent: 'center',
        alignItems: 'center',
        paddingVertical: size.A,
        paddingHorizontal: size.B
    },
    text: {
        color: color.pending.solid,
        fontSize: 11,
        lineHeight: 13,
        letterSpacing: -0.01,
        textTransform: 'uppercase'
    }
}));
//# sourceMappingURL=index.js.map